import { render, staticRenderFns } from "./ItemAuction.vue?vue&type=template&id=1e8ea3e1"
import script from "./ItemAuction.vue?vue&type=script&lang=js"
export * from "./ItemAuction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports